import React, {
    useState,
    useEffect,
    useReducer,
    useContext,
    useRef,
} from "react";
import { socketConnection } from "../../services/socket";
import { toast } from "sonner";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import BlockIcon from "@material-ui/icons/Block";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal/";

import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from '../../utils/formatSerializedId';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import {
    ArrowDropDown,
    Backup,
    ContactPhone,
} from "@material-ui/icons";
import { Menu, MenuItem, TablePagination } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import useTableStyles from "../../components/TableStyles";

const reducer = (state, action) => {
    if (action.type === "LOAD_CONTACTS") {
        const contacts = action.payload;
        return [...contacts];
    }

    if (action.type === "UPDATE_CONTACTS") {
        const contact = action.payload;
        const contactIndex = state.findIndex((c) => c.id === contact.id);

        if (contactIndex !== -1) {
            state[contactIndex] = contact;
            return [...state];
        } else {
            return state;
        }
    }

    if (action.type === "DELETE_CONTACT") {
        const contactId = action.payload;

        const contactIndex = state.findIndex((c) => c.id === contactId);
        if (contactIndex !== -1) {
            state.splice(contactIndex, 1);
        }
        return [...state];
    }

    if (action.type === "RESET") {
        return [];
    }
};

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(2, 3),
        overflowY: "auto",
        ...theme.scrollbarStyles,
    },
    phoneInputCell: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        "& .react-tel-input": {
            width: "auto",
        },
        "& .react-tel-input .form-control": {
            width: "140px",
            border: "none",
            background: "transparent",
            fontSize: 14,
            fontFamily: '"Inter", "Poppins", sans-serif',
            color: theme.palette.type === "dark" ? "#E2E8F0" : "#334155",
            paddingLeft: 40,
        },
        "& .react-tel-input .flag-dropdown": {
            border: "none",
            background: "transparent",
        },
    },
    importMenu: {
        "& .MuiPaper-root": {
            borderRadius: 12,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            border: theme.palette.type === "dark"
                ? "1px solid rgba(255,255,255,0.08)"
                : "1px solid #E2E8F0",
        },
        "& .MuiMenuItem-root": {
            fontFamily: '"Inter", "Poppins", sans-serif',
            fontSize: 14,
            padding: "10px 16px",
            gap: 10,
        },
    },
}));

const Contacts = () => {
    const classes = useStyles();
    const tableClasses = useTableStyles();
    const history = useHistory();

    const { user } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [count, setCount] = useState(0);
    const [reloadCounter, setReloadCounter] = useState(0);
    const [searchParam, setSearchParam] = useState("");
    const [contacts, dispatch] = useReducer(reducer, []);
    const [selectedContactId, setSelectedContactId] = useState(null);
    const [contactModalOpen, setContactModalOpen] = useState(false);

    const [importContactModalOpen, setImportContactModalOpen] = useState(false);
    const [deletingContact, setDeletingContact] = useState(null);
    const [ImportContacts, setImportContacts] = useState(null);
    const [blockingContact, setBlockingContact] = useState(null);
    const [unBlockingContact, setUnBlockingContact] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [exportContact, setExportContact] = useState(false);
    const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
    const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
    const [contactTicket, setContactTicket] = useState({});
    const fileUploadRef = useRef(null);
    const [selectedTags, setSelectedTags] = useState([]);


    const { get: getSetting } = useCompanySettings();
    const [hideNum, setHideNum] = useState(false);

    useEffect(() => {

        async function fetchData() {
            const setting = await getSetting({
                "column": "lgpdHideNumber"
            });

            if (setting.lgpdHideNumber === "enabled") {
                setHideNum(true);
            }
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleImportExcel = async () => {
        try {
            const formData = new FormData();
            formData.append("file", fileUploadRef.current.files[0]);
            await api.request({
                url: `/contacts/upload`,
                method: "POST",
                data: formData,
            });
            history.go(0);
        } catch (err) {
            toastError(err);
        }
    };

    useEffect(() => {
        dispatch({ type: "RESET" });
        setPageNumber(1);
    }, [searchParam, selectedTags]);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const { data } = await api.get("/contacts/", {
                        params: { searchParam, pageNumber, pageSize: rowsPerPage, contactTag: JSON.stringify(selectedTags) },
                    });
                    dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
                    setCount(data.count);
                    setLoading(false);
                } catch (err) {
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, pageNumber, rowsPerPage, selectedTags, reloadCounter]);

    useEffect(() => {
        const companyId = user.companyId;
        const socket = socketConnection({ companyId, userId: user.id });

        socket.on(`company-${companyId}-contact`, (data) => {
            if (data.action === "update") {
                dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
            }

            if (data.action === "create") {
                setPageNumber(1);
                setReloadCounter((prevState) => prevState + 1);
            }

            if (data.action === "delete") {
                dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
                setReloadCounter((prevState) => prevState + 1);
            }
        });

        return () => {
            socket.disconnect();
        };
    }, []);

    const handleCloseOrOpenTicket = (ticket) => {
        setNewTicketModalOpen(false);
        if (ticket !== undefined && ticket.uuid !== undefined) {
            history.push(`/tickets/${ticket.uuid}`);
        }
    };

    const handleSelectedTags = (selecteds) => {
        const tags = selecteds.map((t) => t.id);
        setSelectedTags(tags);
    };

    const handleSearch = (event) => {
        setSearchParam(event.target.value.toLowerCase());
    };

    const handleOpenContactModal = () => {
        setSelectedContactId(null);
        setContactModalOpen(true);
    };

    const handleCloseContactModal = () => {
        setSelectedContactId(null);
        setContactModalOpen(false);
    };

    const hadleEditContact = (contactId) => {
        setSelectedContactId(contactId);
        setContactModalOpen(true);
    };

    const handleDeleteContact = async (contactId) => {
        try {
            await api.delete(`/contacts/${contactId}`);
            toast.success(i18n.t("contacts.toasts.deleted"));
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
    };

    const handleBlockContact = async (contactId) => {
        try {
            await api.put(`/contacts/block/${contactId}`, { active: false });
            toast.success("Contato bloqueado");
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
        setBlockingContact(null);
    };

    const handleUnBlockContact = async (contactId) => {
        try {
            await api.put(`/contacts/block/${contactId}`, { active: true });
            toast.success("Contato desbloqueado");
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
        setUnBlockingContact(null);
    };

    const handleimportContact = async () => {
        try {
            await api.post("/contacts/import");
            history.go(0);
            setImportContacts(false);
        } catch (err) {
            toastError(err);
            setImportContacts(false);
        }
    };

    const handleimportChats = async () => {
        try {
            await api.post("/contacts/import/chats");
            history.go(0);
        } catch (err) {
            toastError(err);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPageNumber(1);
    };

    function getDateLastMessage(contact) {
        if (!contact) return null;
        if (!contact.tickets) return null;

        if (contact.tickets.length > 0) {
            const date = new Date(
                contact.tickets[contact.tickets.length - 1].updatedAt
            );

            const day =
                date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            const hours = date.getHours();
            const minutes = date.getMinutes();

            return `${day}/${month}/${year} ${hours}:${minutes}`;
        }

        return null;
    }

    return (

        <MainContainer className={classes.mainContainer}>
            <NewTicketModal
                modalOpen={newTicketModalOpen}
                initialContact={contactTicket}
                onClose={(ticket) => {
                    handleCloseOrOpenTicket(ticket);
                }}
            />
            <ContactModal
                open={contactModalOpen}
                onClose={handleCloseContactModal}
                aria-labelledby="form-dialog-title"
                contactId={selectedContactId}
            ></ContactModal>
            <ConfirmationModal
                title={
                    deletingContact
                        ? `${i18n.t(
                            "contacts.confirmationModal.deleteTitle"
                        )} ${deletingContact.name}?`
                        : blockingContact
                            ? `Bloquear Contato ${blockingContact.name}?`
                            : unBlockingContact
                                ? `Desbloquear Contato ${unBlockingContact.name}?`
                                : ImportContacts
                                    ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
                                    : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
                }
                open={confirmOpen}
                onClose={setConfirmOpen}
                onConfirm={(e) =>
                    deletingContact
                        ? handleDeleteContact(deletingContact.id)
                        : blockingContact
                            ? handleBlockContact(blockingContact.id)
                            : unBlockingContact
                                ? handleUnBlockContact(unBlockingContact.id)
                                : ImportContacts
                                    ? handleimportContact()
                                    : handleImportExcel()
                }
            >
                {exportContact
                    ?
                    `${i18n.t("contacts.confirmationModal.exportContact")}`
                    : deletingContact
                        ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
                        : blockingContact
                            ? `${i18n.t("contacts.confirmationModal.blockContact")}`
                            : unBlockingContact
                                ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
                                : ImportContacts
                                    ? `${i18n.t("contacts.confirmationModal.importMessage")}`
                                    : `${i18n.t(
                                        "contactListItems.confirmationModal.importMessage"
                                    )}`}
            </ConfirmationModal>
            <ConfirmationModal
                title={i18n.t("contacts.confirmationModal.importChat")}
                open={confirmChatsOpen}
                onClose={setConfirmChatsOpen}
                onConfirm={(e) => handleimportChats()}
            >
                {i18n.t("contacts.confirmationModal.wantImport")}
            </ConfirmationModal>
            <MainHeader>
                <Title>{i18n.t("contacts.title")} ({count})</Title>
                <MainHeaderButtonsWrapper>
                    <TagsFilter
                        onFiltered={handleSelectedTags}
                    />
                    <TextField
                        placeholder={i18n.t("contacts.searchPlaceholder")}
                        type="search"
                        value={searchParam}
                        onChange={handleSearch}
                        size="small"
                        className={tableClasses.searchField}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon style={{ color: "#94A3B8", fontSize: 20 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                            <React.Fragment>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={tableClasses.addButton}
                                    {...bindTrigger(popupState)}
                                >
                                    Importar / Exportar
                                    <ArrowDropDown style={{ marginLeft: 4 }} />
                                </Button>
                                <Menu
                                    {...bindMenu(popupState)}
                                    className={classes.importMenu}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            setConfirmOpen(true);
                                            setImportContacts(true);
                                            popupState.close();
                                        }}
                                    >
                                        <ContactPhone
                                            fontSize="small"
                                            style={{ color: "#35af9a" }}
                                        />
                                        {i18n.t("contacts.menu.importYourPhone")}
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => { setImportContactModalOpen(true) }}
                                    >
                                        <Backup
                                            fontSize="small"
                                            style={{ color: "#35af9a" }}
                                        />
                                        {i18n.t("contacts.menu.importToExcel")}
                                    </MenuItem>
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOpenContactModal}
                        className={tableClasses.addButton}
                    >
                        {i18n.t("contacts.buttons.add")}
                    </Button>
                </MainHeaderButtonsWrapper>
            </MainHeader>

            <ContactImportWpModal
                isOpen={importContactModalOpen}
                handleClose={() => setImportContactModalOpen(false)}
                selectedTags={selectedTags}
                hideNum={hideNum}
                userProfile={user.profile}
            />
            <Paper
                className={`${classes.mainPaper} ${tableClasses.tableContainer}`}
                elevation={0}
            >
                <>
                    <input
                        style={{ display: "none" }}
                        id="upload"
                        name="file"
                        type="file"
                        accept=".xls,.xlsx"
                        onChange={() => {
                            setConfirmOpen(true);
                        }}
                        ref={fileUploadRef}
                    />
                </>
                <Table size="small">
                    <TableHead className={tableClasses.tableHead}>
                        <TableRow>
                            <TableCell padding="checkbox" className={tableClasses.tableHeadCell} />
                            <TableCell className={tableClasses.tableHeadCell}>
                                {i18n.t("contacts.table.name")}
                            </TableCell>
                            <TableCell align="center" className={tableClasses.tableHeadCell}>
                                {i18n.t("contacts.table.whatsapp")}
                            </TableCell>
                            <TableCell align="center" className={tableClasses.tableHeadCell}>
                                {i18n.t("contacts.table.email")}
                            </TableCell>
                            <TableCell align="center" className={tableClasses.tableHeadCell}>
                                {i18n.t("contacts.table.lastMessage")}
                            </TableCell>
                            <TableCell align="center" className={tableClasses.tableHeadCell}>
                                {"Status"}
                            </TableCell>
                            <TableCell align="center" className={tableClasses.tableHeadCell}>
                                {i18n.t("contacts.table.actions")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                            {contacts.map((contact) => (
                                <TableRow key={contact.id} className={tableClasses.tableRow}>
                                    <TableCell style={{ paddingRight: 0 }} className={tableClasses.tableCell}>
                                        <Avatar
                                            src={`${contact?.urlPicture}`}
                                            className={tableClasses.avatarCell}
                                        />
                                    </TableCell>
                                    <TableCell className={tableClasses.tableCellBold}>
                                        {contact.name}
                                    </TableCell>
                                    <TableCell align="center" className={tableClasses.tableCell}>
                                        <div className={classes.phoneInputCell}>
                                            <PhoneInput
                                                value={contact.number}
                                                country={contact.number.startsWith('+') ? contact.number.slice(1, 3) : 'br'}
                                                disableCountryCode={false}
                                                onlyCountries={[
                                                    'af', 'al', 'dz', 'as', 'ad', 'ao', 'ai', 'aq', 'ag', 'ar', 'am', 'aw', 'au',
                                                    'at', 'az', 'bs', 'bh', 'bd', 'bb', 'by', 'be', 'bz', 'bj', 'bm', 'bt', 'bo',
                                                    'ba', 'bw', 'br', 'bn', 'bg', 'bf', 'bi', 'kh', 'cm', 'ca', 'cv', 'cf', 'td',
                                                    'cl', 'cn', 'co', 'km', 'cg', 'cd', 'cr', 'hr', 'cu', 'cy', 'cz', 'dk', 'dj',
                                                    'dm', 'do', 'ec', 'eg', 'sv', 'gq', 'er', 'ee', 'et', 'fk', 'fo', 'fj', 'fi',
                                                    'fr', 'gf', 'pf', 'ga', 'gm', 'ge', 'de', 'gh', 'gi', 'gr', 'gl', 'gd', 'gp',
                                                    'gu', 'gt', 'gn', 'gw', 'gy', 'ht', 'hn', 'hk', 'hu', 'is', 'in', 'id', 'ir',
                                                    'iq', 'ie', 'il', 'it', 'jm', 'jp', 'jo', 'kz', 'ke', 'ki', 'kp', 'kr', 'kw',
                                                    'kg', 'la', 'lv', 'lb', 'ls', 'lr', 'ly', 'li', 'lt', 'lu', 'mo', 'mk', 'mg',
                                                    'mw', 'my', 'mv', 'ml', 'mt', 'mh', 'mq', 'mr', 'mu', 'yt', 'mx', 'fm', 'md',
                                                    'mc', 'mn', 'me', 'ma', 'mz', 'mm', 'na', 'nr', 'np', 'nl', 'nc', 'nz', 'ni',
                                                    'ne', 'ng', 'nu', 'nf', 'mp', 'no', 'om', 'pk', 'pw', 'ps', 'pa', 'pg', 'py',
                                                    'pe', 'ph', 'pl', 'pt', 'pr', 'qa', 're', 'ro', 'ru', 'rw', 'sh', 'kn', 'lc',
                                                    'pm', 'vc', 'ws', 'sm', 'st', 'sa', 'sn', 'rs', 'sc', 'sl', 'sg', 'sk', 'si',
                                                    'sb', 'so', 'za', 'es', 'lk', 'sd', 'sr', 'sz', 'se', 'ch', 'sy', 'tw', 'tj',
                                                    'tz', 'th', 'tl', 'tg', 'to', 'tt', 'tn', 'tr', 'tm', 'tc', 'tv', 'ug', 'ua',
                                                    'ae', 'gb', 'us', 'uy', 'uz', 'vu', 'va', 've', 'vn', 'wf', 'ye', 'zm', 'zw'
                                                ]}
                                                disableDropdown={true}
                                                inputStyle={{
                                                    width: '140px',
                                                    textAlign: 'left',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    paddingLeft: '40px',
                                                    fontSize: '14px',
                                                    fontFamily: '"Inter", "Poppins", sans-serif',
                                                }}
                                                buttonStyle={{
                                                    position: 'absolute',
                                                    left: '0',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    padding: '0',
                                                }}
                                                isValid={(value) => value && value.length > 0}
                                                placeholder="Número não disponível"
                                            />
                                        </div>
                                    </TableCell>

                                    <TableCell align="center" className={tableClasses.tableCell}>
                                        {contact.email}
                                    </TableCell>
                                    <TableCell align="center" className={tableClasses.tableCell}>
                                        {getDateLastMessage(contact)}
                                    </TableCell>
                                    <TableCell align="center" className={tableClasses.tableCell}>
                                        {contact.active ? (
                                            <Chip
                                                label="Ativo"
                                                size="small"
                                                className={`${tableClasses.statusChip} ${tableClasses.statusActive}`}
                                            />
                                        ) : (
                                            <Chip
                                                label="Bloqueado"
                                                size="small"
                                                className={`${tableClasses.statusChip} ${tableClasses.statusInactive}`}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell align="center" className={tableClasses.tableCell}>
                                        <div className={tableClasses.actionButtonGroup}>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setContactTicket(contact);
                                                    setNewTicketModalOpen(true);
                                                }}
                                                className={`${tableClasses.actionButton} ${tableClasses.actionButtonChannel}`}
                                            >
                                                {contact.channel === "whatsapp" && (<WhatsApp fontSize="small" />)}
                                                {contact.channel === "instagram" && (<Instagram fontSize="small" />)}
                                                {contact.channel === "facebook" && (<Facebook fontSize="small" />)}
                                                {!contact.channel && (<WhatsApp fontSize="small" />)}
                                            </IconButton>

                                            <IconButton
                                                size="small"
                                                onClick={() =>
                                                    hadleEditContact(contact.id)
                                                }
                                                className={`${tableClasses.actionButton} ${tableClasses.actionButtonEdit}`}
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={
                                                    contact.active
                                                        ? () => {
                                                            setConfirmOpen(true);
                                                            setBlockingContact(
                                                                contact
                                                            );
                                                        }
                                                        : () => {
                                                            setConfirmOpen(true);
                                                            setUnBlockingContact(
                                                                contact
                                                            );
                                                        }
                                                }
                                                className={`${tableClasses.actionButton} ${contact.active ? tableClasses.actionButtonBlock : tableClasses.actionButtonSuccess}`}
                                            >
                                                {contact.active ? (
                                                    <BlockIcon fontSize="small" />
                                                ) : (
                                                    <CheckCircleIcon fontSize="small" />
                                                )}
                                            </IconButton>
                                            <Can
                                                role={user.profile}
                                                perform="contacts-page:deleteContact"
                                                yes={() => (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            setConfirmOpen(true);
                                                            setDeletingContact(
                                                                contact
                                                            );
                                                        }}
                                                        className={`${tableClasses.actionButton} ${tableClasses.actionButtonDelete}`}
                                                    >
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {loading && <TableRowSkeleton avatar columns={5} />}
                        </>
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[20, 60, 100, 150, 300]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={pageNumber - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Contatos Por Página"
                    className={tableClasses.pagination}
                    labelDisplayedRows={({ from, to, count: total }) => {
                        if (!total) return "0 de 0";
                        return `${to - from + 1} de ${total}`;
                    }}
                />
            </Paper>
        </MainContainer >
    );
};

export default Contacts;
